import {Component, Input, ViewEncapsulation} from '@angular/core';
import {Constraint} from "../../_models/solver";
import {Series} from "../../_models/series";
import {SelectSearchComponentComponent} from "../select-search-api/single/select-search-component.component";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'series-formula-builder',
    templateUrl: './series-formula-builder.component.html',
    styleUrls: ['./series-formula-builder.component.less'],
    imports: [
        SelectSearchComponentComponent,
        FormsModule
    ],
    encapsulation: ViewEncapsulation.None
})
export class SeriesFormulaBuilderComponent {
    @Input() constraint: Constraint;
    insert_series: Series;

    addToFormula() {
        if (!this.constraint.attributes.name_formula) {
            this.constraint.attributes.name_formula = '';
        }
        this.constraint.attributes.name_formula += ' [' + this.insert_series.attributes.name + '] ';
    }
}
